import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90e22c60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flexContainer" }
const _hoisted_2 = {
  key: 0,
  class: "contentContainer noSelection"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Friends", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "contentContainer addFriend"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Send friend request", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "friendRequestText" }, " To send a friend request to someone, you’ll need their account code. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_10 = {
  key: 0,
  class: "error"
}
const _hoisted_11 = {
  key: 1,
  class: "friendRequestSuccess"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Account code", -1))
const _hoisted_14 = { class: "accountCodeContainer" }
const _hoisted_15 = { class: "accountCode" }
const _hoisted_16 = { class: "copyAccountCodeContainer" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sharing your account code lets other people send friend requests to you.", -1))
const _hoisted_18 = {
  key: 2,
  class: "friendRequestSuccess"
}
const _hoisted_19 = {
  key: 2,
  class: "contentContainer viewFriend"
}
const _hoisted_20 = { class: "monogram" }

import MainSidebar from "@/components/MainSidebar.vue";
import FriendsSidebar from "@/components/FriendsSidebar.vue";
import NextIcon from "@/components/Icons/NextIcon.vue";
import ErrorIcon from "@/components/Icons/ErrorIcon.vue";
import CancelIcon from "@/components/Icons/CancelIcon.vue";
import HeyButton from "@/components/HeyButton.vue";
import CopyIcon from "@/components/Icons/CopyIcon.vue";
import { ComputedRef, computed, onUpdated, ref } from "vue";
import { useStore } from "vuex";
import axios, { AxiosError } from "axios";
import router from "@/router";
import CheckmarkIcon from "@/components/Icons/CheckmarkIcon.vue";

// Type declations
type User = {
  user_id: string;
  name: string;
  avatar?: string;
};
type Friendship = {
  friendship_id: string;
  user: User;
};

// Vuex Store

export default /*#__PURE__*/_defineComponent({
  __name: 'FriendsView',
  setup(__props) {

const store = useStore();
const friends: ComputedRef<Record<string, Friendship[]>> = computed(
  () => store.state.friends
);
const currentFriend: ComputedRef<User> = computed(() => {
  const currentFriendship = store.state.friends.current.find(
    (friend: Friendship) => friend.friendship_id == currentlySelected.value
  ) as Friendship;

  return currentFriendship.user;
});

// Variables
const currentlySelected = ref("");
const oldAccountCodeValue = ref("");
const accountCode = ref<HTMLInputElement | null>(null);
const error = ref("");
const sendingFriendRequest = ref(false);
const friendRequestSentTo = ref("");
const accountCodeCopied = ref(false);

onUpdated(() => {
  if (
    !friends.value.current.find(
      (friend) => friend.friendship_id == currentlySelected.value
    ) &&
    currentlySelected.value != "send"
  ) {
    currentlySelected.value = "";
  }
});

async function deleteRequest(friendship_id: string) {
  sendingFriendRequest.value = true;
  await sleep(500);

  try {
    await axios.delete("/friendships/delete", {
      data: { friendship_id: friendship_id },
    });

    store.dispatch("deleteFriendship", friendship_id);

    if (currentlySelected.value == friendship_id) {
      currentlySelected.value = "send";
    }
    sendingFriendRequest.value = false;
  } catch (err) {
    console.log(err);
    sendingFriendRequest.value = false;
  }
}

function getAccountCode(): string | null {
  const accountCodeInputs = accountCode.value?.querySelectorAll("input");
  if (!accountCodeInputs) return null;

  let code = "";

  for (let i = 0; i < accountCodeInputs.length; i++) {
    const accountCodeInput = accountCodeInputs[i] as HTMLInputElement;

    if (accountCodeInput.value) {
      code += (i ? "-" : "") + accountCodeInput.value;
    } else {
      return "";
    }
  }

  return code;
}

function copyAccountCode() {
  if (!accountCodeCopied.value) {
    navigator.clipboard.writeText(store.state.current_user.code);
    accountCodeCopied.value = true;

    setTimeout(() => {
      accountCodeCopied.value = false;
    }, 5000);
  }
}

async function sendFriendRequest() {
  // Don't allow duplicate requests to be sent if already logging in or if there an unaddressed error
  if (sendingFriendRequest.value || error.value) return;

  // Pause script so that user can be spinner, even if response from server is fast
  sendingFriendRequest.value = true;
  await sleep(500);

  // Get account code
  const accountCode = getAccountCode();

  if (accountCode == store.state.current_user.code) {
    sendingFriendRequest.value = false;
    error.value = "You Can't Use Your Own Account Code";
    return;
  }

  if (!accountCode) {
    sendingFriendRequest.value = false;
    error.value = "Account Code Is Required";
    return;
  }

  // Check if account code is valid
  if (!isAccountCode(accountCode)) {
    sendingFriendRequest.value = false;
    error.value = "Not A Valid Account Code";
    return;
  }

  try {
    const { data } = await axios.post("/friendships/create", {
      account_code: accountCode,
    });

    store.dispatch("createNewOutgoingFriendship", {
      friendship_id: data.friendship_id,
      user: data.addressee,
    });

    sendingFriendRequest.value = false;
    emptyAccountCode();

    friendRequestSentTo.value = data.addressee.name;

    setTimeout(() => {
      friendRequestSentTo.value = "";
    }, 5000);
  } catch (err) {
    const e = err as AxiosError;
    const responseData = e.response?.data as string;

    if (responseData) {
      error.value = responseData.replaceAll(".", "");
    }

    sendingFriendRequest.value = false;
  }
}

async function handleBeforeInput(event: Event) {
  const e = event as InputEvent;
  const currentInput = e.target as HTMLInputElement;

  oldAccountCodeValue.value = currentInput.value;
}

async function handleInput(event: Event) {
  const e = event as InputEvent;
  const dataInputted = e.data?.toLowerCase() || "";
  const currentInput = e.target as HTMLInputElement;
  const nextInput = currentInput.nextElementSibling
    ?.nextElementSibling as HTMLInputElement;

  if (dataInputted == "-" && nextInput && currentInput.value.length > 3) {
    nextInput.focus();
    nextInput.select();
  }

  // Stop any invalid input conditions from happening
  if (currentInput.value.length > 6 || !isAlphabetical(dataInputted)) {
    currentInput.value = oldAccountCodeValue.value;
    return;
  }

  currentInput.value = currentInput.value.toLowerCase();
  error.value = "";
}

function handlePaste(event: Event) {
  const e = event as ClipboardEvent;
  e.preventDefault();

  if (!e.clipboardData) return; // Stop function if clipboard data doesn't exist

  const pastedData = e.clipboardData.getData("text/plain").trim();

  // Insert data into verification code fields if number 6-digits or less is pasted
  if (isAccountCode(pastedData)) {
    const inputBoxes = accountCode.value?.querySelectorAll("input");
    if (!inputBoxes) return;

    for (let i = 0; i < inputBoxes.length; i++) {
      const inputBox = inputBoxes[i] as HTMLInputElement;
      inputBox.value = "";

      if (pastedData.split("-")[i]) {
        inputBox.value = pastedData.split("-")[i];
        inputBox.focus();
      }
    }

    error.value = "";

    sendFriendRequest();
  }
}

function handleDelete(event: Event) {
  const e = event as KeyboardEvent;
  const currentInput = e.target as HTMLInputElement;
  const inputBeforeCurrent = currentInput.previousElementSibling
    ?.previousElementSibling as HTMLInputElement | null;

  if (currentInput.value.length == 0 && inputBeforeCurrent) {
    inputBeforeCurrent.focus();
  }
}

function emptyAccountCode() {
  const inputBoxes = accountCode.value?.querySelectorAll("input");
  if (!inputBoxes) return;

  for (let i = 0; i < inputBoxes.length; i++) {
    const inputBox = inputBoxes[i] as HTMLInputElement;
    inputBox.value = "";
  }

  accountCode.value?.querySelectorAll("input")[0].focus();
}

function isAlphabetical(string: string): boolean {
  if (!string) return true;

  return /^[a-z]+$/.test(string);
}

function isAccountCode(string: string): boolean {
  return /^[a-z]{3,6}-[a-z]{3,6}-[a-z]{3,6}$/.test(string);
}

async function sleep(milliseconds: number) {
  await new Promise((resolve) => {
    setTimeout(() => {
      resolve("done");
    }, milliseconds);
  });
}
function getMonogram(name: string) {
  return name.slice(0, 1).toUpperCase();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainSidebar),
    _createVNode(FriendsSidebar, {
      onSelected: _cache[0] || (_cache[0] = 
        (selected) => {
          currentlySelected.value = selected;
          error.value = '';
        }
      )
    }),
    (!currentlySelected.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (currentlySelected.value == 'send')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("div", {
              class: _normalizeClass(['accountCodeInput', error.value ? 'error' : '']),
              ref_key: "accountCode",
              ref: accountCode
            }, [
              _createElementVNode("input", {
                onInput: handleInput,
                onBeforeinput: handleBeforeInput,
                onPaste: handlePaste,
                onKeydown: [
                  _withKeys(handleDelete, ["delete"]),
                  _withKeys(sendFriendRequest, ["enter"])
                ],
                spellcheck: "false"
              }, null, 32),
              _hoisted_8,
              _createElementVNode("input", {
                onInput: handleInput,
                onBeforeinput: handleBeforeInput,
                onPaste: handlePaste,
                onKeydown: [
                  _withKeys(handleDelete, ["delete"]),
                  _withKeys(sendFriendRequest, ["enter"])
                ],
                spellcheck: "false"
              }, null, 32),
              _hoisted_9,
              _createElementVNode("input", {
                onInput: handleInput,
                onBeforeinput: handleBeforeInput,
                onPaste: handlePaste,
                onKeydown: [
                  _withKeys(handleDelete, ["delete"]),
                  _withKeys(sendFriendRequest, ["enter"])
                ],
                spellcheck: "false"
              }, null, 32)
            ], 2),
            (error.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  _createElementVNode("span", null, [
                    _createVNode(ErrorIcon)
                  ]),
                  _createTextVNode(" " + _toDisplayString(error.value), 1)
                ]))
              : _createCommentVNode("", true),
            (friendRequestSentTo.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                  _createElementVNode("span", null, [
                    _createVNode(CheckmarkIcon, { color: "#fff" })
                  ]),
                  _createTextVNode(" Sent a friend request to “" + _toDisplayString(friendRequestSentTo.value) + "” ", 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(HeyButton, {
              loading: sendingFriendRequest.value,
              onClick: sendFriendRequest,
              class: "friendRequestButton"
            }, {
              default: _withCtx(() => [
                _createVNode(NextIcon),
                _createTextVNode("Send")
              ]),
              _: 1
            }, 8, ["loading"]),
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h1", _hoisted_15, _toDisplayString(_unref(store).state.current_user.code), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "copyAccountCode",
                  title: "Copy Account Code",
                  onClick: copyAccountCode
                }, [
                  _createVNode(CopyIcon)
                ])
              ])
            ]),
            _hoisted_17,
            (accountCodeCopied.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                  _createElementVNode("span", null, [
                    _createVNode(CheckmarkIcon, { color: "#fff" })
                  ]),
                  _createTextVNode(" Account code copied to clipboard! ")
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, _toDisplayString(getMonogram(currentFriend.value.name)), 1),
            _createElementVNode("h1", null, _toDisplayString(currentFriend.value.name), 1),
            _createVNode(HeyButton, {
              loading: sendingFriendRequest.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteRequest(currentlySelected.value)))
            }, {
              default: _withCtx(() => [
                _createVNode(CancelIcon, { color: "#fff" }),
                _createTextVNode("Unfriend")
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(HeyButton, {
              type: "secondary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push(`/messages/${currentFriend.value.user_id}`)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Go to conversation"),
                _createVNode(NextIcon, { color: "#000" })
              ]),
              _: 1
            })
          ]))
  ]))
}
}

})